module.exports = __webpack_public_path__ + "img/RMRGreen_Logo_White.b9068fa5.png";